<template>
  <div class="woori-crowdfunding">
    <div class="wrap">
      <div class="hero">
        <div class="top">
          <div class="logo">
            <div class="mk">F</div>
            <div class="nm">
              펀다에이아이
              <small>FUNDA A.I.</small>
            </div>
          </div>
          <div class="chip">소상공인 전문 온투업</div>
        </div>

        <div class="ey">매출이 있는 날, 그날그날 갚는 대출</div>
        <h1>
          우리동네 사장님<br />
          <span class="hl">500만원 즉시 대출</span>
        </h1>
        <p>
          신용등급이 아닌 매출로 한도를 정하고, 카드매출에서 매일 조금씩 갚는
          부담 없는 대출.
        </p>

        <div class="kpis">
          <div class="kpi">
            <div class="n">500만원</div>
            <div class="l">즉시 대출</div>
          </div>
          <div class="kpi">
            <div class="n">신용 4~6등급</div>
            <div class="l">신청 가능</div>
          </div>
          <div class="kpi">
            <div class="n">매일 일정액</div>
            <div class="l">자동 상환</div>
          </div>
        </div>
      </div>

      <div class="cf">
        <span class="new">NEW</span>
        <span class="b">🏛️ 2026 우리동네 크라우드펀딩</span>
        <div class="ch"><em>500만원</em> 즉시 대출 + 혜택</div>
        <ul>
          <li>
            <span>✓</span>
            <div class="benefit-text">
              투자 모집을 기다릴 필요 없이 <b>바로 대출</b>
            </div>
          </li>
          <li>
            <span>✓</span>
            <div class="benefit-text">펀딩 <b>수수료 전액 환급</b></div>
          </li>
          <li>
            <span>✓</span>
            <div class="benefit-text">
              대출금액의 <b>4.5% 마케팅 지원금</b>
              <small>(이자보다 높은 수준)</small>
            </div>
          </li>
          <li>
            <span>✓</span>
            <div class="benefit-text">
              사실상 <b>무이자보다 유리한, 적금 같은 대출</b>
            </div>
          </li>
        </ul>
      </div>

      <div class="sec">
        <span class="eyebrow">● 펀다에이아이가 유리한 이유</span>
        <div class="h2">신용보다 매출을 봅니다</div>
        <div class="cards">
          <div class="c">
            <div class="i">📈</div>
            <div>
              <div class="t">매출 기반 한도</div>
              <div class="d">
                신용등급이 아닌 <b>월평균 매출액의 30%</b>로 한도 산정.
                카드·앱·온라인·현금 매출까지 인정돼요.
              </div>
            </div>
          </div>

          <div class="c">
            <div class="i">🗓️</div>
            <div>
              <div class="t">카드매출 일상환</div>
              <div class="d">
                만기에 목돈 한 번이 아니라, 카드매출에서
                <b>매일 정해진 일정액</b>이 자동 상환됩니다.
              </div>
            </div>
          </div>

          <div class="c">
            <div class="i">🪪</div>
            <div>
              <div class="t">신용 4~6등급도 신청</div>
              <div class="d">
                중·저신용 자영업자도 신청 가능. AI 매출 분석으로 상환 여력을
                봅니다.
              </div>
            </div>
          </div>

          <div class="c">
            <div class="i">📄</div>
            <div>
              <div class="t">서류는 단 3가지</div>
              <div class="d">
                사업자등록증·신분증·경남은행 통장 사본이면 끝. 타 기관보다 훨씬
                간단해요.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="sec">
        <span class="eyebrow">● 신청 흐름</span>
        <div class="h2">신청부터 상환까지</div>
        <div class="flow">
          <div class="fstep">
            <div class="fnum">1</div>
            <div class="ftx">
              <div class="ft">매출 분석 · 한도 산정</div>
              <div class="fd">월평균 매출액의 30%를 한도로 산정</div>
            </div>
          </div>
          <div class="fstep">
            <div class="fnum">2</div>
            <div class="ftx">
              <div class="ft">우리동네 펀딩이면 즉시 대출</div>
              <div class="fd">
                일반 신청은 익일부터 투자 모집, 우리동네는 500만원 즉시
              </div>
            </div>
          </div>
          <div class="fstep">
            <div class="fnum">3</div>
            <div class="ftx">
              <div class="ft">사업 자금 지급</div>
              <div class="fd">필요한 자금을 사업장으로</div>
            </div>
          </div>
          <div class="fstep">
            <div class="fnum">4</div>
            <div class="ftx">
              <div class="ft">매일 자동 상환</div>
              <div class="fd">카드매출에서 매일 정해진 일정액 자동 차감</div>
            </div>
          </div>
        </div>
      </div>

      <div class="docs">
        <div class="dh">
          준비 서류 3가지
          <span>이것만 있으면 신청 완료</span>
        </div>
        <div class="docchips">
          <div class="dchip">📋 사업자등록증</div>
          <div class="dchip">🪪 신분증</div>
          <div class="dchip">🏦 경남은행 통장 사본</div>
        </div>
      </div>

      <div class="risk">
        <div class="rt">대출 전 안내</div>
        <p>
          펀다에이아이는 「온라인투자연계금융업 및 이용자 보호에 관한 법률」에
          따라 등록된 온투업 회사입니다. 한도·금리·상환액 등 세부 조건은 매출과
          심사 결과에 따라 달라지며, 일반 상품은 투자 모집 절차에 따라 지급
          금액·시점이 달라질 수 있습니다. 상환능력에 비해 대출이 과도할 경우
          신용에 불이익이 발생할 수 있고, 연체 시 만기 전 원리금 상환 의무가
          발생할 수 있습니다.
        </p>
      </div>

      <div class="cta">
        <button class="main" type="button" @click="openApplicationDialog">
          대출 신청하기 →
        </button>
      </div>

      <div
        v-if="applicationDialog"
        class="application-modal"
        @click.self="closeApplicationDialog"
      >
        <form class="application-form" @submit.prevent="submitApplication">
          <div class="modal-head">
            <div>
              <div class="modal-title">대출 신청 정보</div>
              <div class="modal-subtitle">담당자가 신청 내용을 확인합니다</div>
            </div>
            <button
              type="button"
              class="modal-close"
              @click="closeApplicationDialog"
            >
              ×
            </button>
          </div>

          <label>
            <span>사업자번호</span>
            <input
              v-model.trim="applicationForm.businessLicenseNumber"
              type="text"
              maxlength="20"
              inputmode="numeric"
              placeholder="사업자번호(- 없이 입력)"
              required
            />
          </label>
          <label>
            <span>매장명</span>
            <input
              v-model.trim="applicationForm.storeName"
              type="text"
              maxlength="100"
              placeholder="매장명"
              required
            />
          </label>
          <label>
            <span>이름</span>
            <input
              v-model.trim="applicationForm.ownerName"
              type="text"
              maxlength="50"
              placeholder="이름"
              required
            />
          </label>
          <label>
            <span>핸드폰번호</span>
            <input
              v-model.trim="applicationForm.phoneNumber"
              type="tel"
              maxlength="20"
              inputmode="tel"
              placeholder="핸드폰번호(- 없이 입력)"
              required
            />
          </label>

          <div v-if="applicationError" class="form-error">
            {{ applicationError }}
          </div>

          <button
            class="submit"
            type="submit"
            :disabled="applicationSubmitting"
          >
            {{ applicationSubmitting ? '저장 중' : '신청 정보 저장' }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'WooriCrowdfunding',
  data() {
    return {
      applicationDialog: false,
      applicationSubmitting: false,
      applicationError: '',
      applicationForm: {
        businessLicenseNumber: '',
        storeName: '',
        ownerName: '',
        phoneNumber: ''
      }
    }
  },
  methods: {
    getUtmParams() {
      const utmSource = this.$route.query.utm_source || this.$route.query.source
      const utmContent =
        this.$route.query.utm_content || this.$route.query.campaign
      return {
        utmSource,
        utmContent
      }
    },
    openApplicationDialog() {
      this.resetApplicationForm()
      this.applicationDialog = true
    },
    closeApplicationDialog() {
      if (this.applicationSubmitting) {
        return
      }
      this.applicationDialog = false
      this.resetApplicationForm()
    },
    resetApplicationForm() {
      this.applicationForm = {
        businessLicenseNumber: '',
        storeName: '',
        ownerName: '',
        phoneNumber: ''
      }
      this.applicationError = ''
    },
    normalizeDigits(value) {
      return String(value || '').replace(/\D/g, '')
    },
    validateApplicationForm() {
      if (!this.applicationForm.businessLicenseNumber) {
        return '사업자번호를 입력해주세요.'
      }
      if (!this.applicationForm.storeName) {
        return '매장명을 입력해주세요.'
      }
      if (!this.applicationForm.ownerName) {
        return '이름을 입력해주세요.'
      }
      if (!this.applicationForm.phoneNumber) {
        return '핸드폰번호를 입력해주세요.'
      }
      return ''
    },
    async submitApplication() {
      const error = this.validateApplicationForm()
      if (error) {
        this.applicationError = error
        return
      }

      const { utmSource, utmContent } = this.getUtmParams()
      this.applicationSubmitting = true
      this.applicationError = ''

      try {
        await axios({
          method: 'POST',
          url: `${process.env.common.nowApi.host}/api/loan-application-leads/`,
          data: {
            productCode: 'woori_crowdfunding',
            utmSource,
            utmContent,
            landingUrl: window.location.href,
            businessLicenseNumber: this.normalizeDigits(
              this.applicationForm.businessLicenseNumber
            ),
            storeName: this.applicationForm.storeName,
            ownerName: this.applicationForm.ownerName,
            phoneNumber: this.normalizeDigits(this.applicationForm.phoneNumber)
          }
        })
        alert('신청 정보가 저장되었습니다. 담당자가 확인 후 연락드리겠습니다.')
        this.applicationDialog = false
        this.resetApplicationForm()
      } catch (e) {
        console.log('[WooriCrowdfunding.submitApplication] error', e)
        const message = this.getApplicationErrorMessage(e)
        this.applicationError = message
        alert(message)
      } finally {
        this.applicationSubmitting = false
      }
    },
    getApplicationErrorMessage(e) {
      const detail = e.response && e.response.data && e.response.data.detail
      if (detail === 'businessLicenseNumber is required') {
        return '사업자번호를 입력해주세요.'
      }
      if (detail === 'storeName is required') {
        return '매장명을 입력해주세요.'
      }
      if (detail === 'ownerName is required') {
        return '이름을 입력해주세요.'
      }
      if (detail === 'phoneNumber is required') {
        return '핸드폰번호를 입력해주세요.'
      }
      if (detail) {
        return detail
      }
      return '신청 정보 저장 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.'
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+KR:wght@300;400;500;600;700&family=Black+Han+Sans&display=swap');

.woori-crowdfunding {
  --blue: #08a8dc;
  --blue-ink: #087eaa;
  --blue-soft: #eaf8fd;
  --blue-tint: #f7fcfe;
  --ink: #23282f;
  --sub: #5b636d;
  --muted: #9aa1a9;
  --line: #dde8ef;
  --paper: #fff;
  --red: #ec3f62;
  --panel: #fbfdfe;
  --shadow-soft: 0 18px 44px -36px rgba(20, 40, 60, 0.48);

  box-sizing: border-box;
  background: #eef3f6;
  color: var(--ink);
  font-family: 'IBM Plex Sans KR', sans-serif;
  line-height: 1.55;
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  .wrap {
    max-width: 460px;
    margin: 0 auto;
    background: var(--paper);
    min-height: 100vh;
    padding-bottom: 96px;
    position: relative;
    overflow: hidden;
  }

  .hero {
    padding: 26px 24px 28px;
    position: relative;
    overflow: hidden;
    background: radial-gradient(
        420px 240px at 92% -8%,
        rgba(0, 173, 229, 0.22),
        transparent 62%
      ),
      linear-gradient(180deg, #f4fbfe, #ffffff);

    .ey {
      font-size: 13px;
      color: var(--blue-ink);
      font-weight: 500;
      margin-top: 22px;
    }

    h1 {
      font-family: 'Black Han Sans', sans-serif;
      font-weight: 400;
      font-size: 36px;
      line-height: 1.16;
      margin: 8px 0 0;
      color: var(--ink);

      .hl {
        color: var(--blue);
      }
    }

    p {
      font-size: 14px;
      font-weight: 400;
      color: var(--sub);
      margin: 14px 0 0;
      line-height: 1.65;
    }
  }

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .logo {
    display: flex;
    align-items: center;
    gap: 9px;

    .mk {
      width: 32px;
      height: 32px;
      border-radius: 9px;
      background: var(--blue);
      color: #fff;
      display: grid;
      place-items: center;
      font-family: 'Black Han Sans', sans-serif;
      font-size: 20px;
    }

    .nm {
      font-family: 'Black Han Sans', sans-serif;
      font-size: 19px;
      color: var(--blue);

      small {
        font-family: 'IBM Plex Sans KR', sans-serif;
        font-weight: 400;
        font-size: 10px;
        color: var(--muted);
        display: block;
      }
    }
  }

  .chip {
    font-size: 11px;
    font-weight: 600;
    color: var(--blue-ink);
    background: var(--blue-soft);
    border: 1px solid #cdeefb;
    border-radius: 999px;
    padding: 6px 11px;
  }

  .kpis {
    display: flex;
    gap: 10px;
    margin-top: 22px;
  }

  .kpi {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #fff;
    border: 1px solid var(--line);
    border-radius: 13px;
    padding: 12px 8px;
    min-height: 74px;
    text-align: center;
    box-shadow: 0 6px 16px -12px rgba(20, 40, 60, 0.25);

    .n {
      font-family: 'Black Han Sans', sans-serif;
      font-size: 15px;
      line-height: 1.1;
      color: var(--blue);
    }

    .l {
      font-size: 10px;
      color: var(--muted);
      margin-top: 3px;
      line-height: 1.3;
    }
  }

  .cf {
    margin: 22px 24px 0;
    background: #fff;
    border: 1.5px solid var(--blue);
    border-radius: 18px;
    padding: 20px;
    position: relative;

    .new {
      position: absolute;
      top: 16px;
      right: 18px;
      font-size: 10.5px;
      font-weight: 700;
      color: #fff;
      background: var(--red);
      border-radius: 6px;
      padding: 3px 8px;
    }

    .b {
      display: inline-block;
      font-size: 11.5px;
      font-weight: 700;
      color: var(--blue-ink);
      background: var(--blue-soft);
      border: 1px solid #cdeefb;
      border-radius: 999px;
      padding: 6px 12px;
      margin-bottom: 12px;
    }

    .ch {
      font-family: 'Black Han Sans', sans-serif;
      font-weight: 400;
      font-size: 26px;
      color: var(--ink);
      line-height: 1.2;

      em {
        font-style: normal;
        color: var(--red);
      }
    }

    ul {
      list-style: none;
      margin: 14px 0 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      gap: 9px;
    }

    li {
      font-size: 13px;
      color: var(--ink);
      font-weight: 400;
      display: flex;
      gap: 9px;
      align-items: flex-start;
      line-height: 1.45;

      span {
        flex: none;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background: var(--blue);
        color: #fff;
        display: grid;
        place-items: center;
        font-size: 10px;
        font-weight: 700;
        margin-top: 1px;
      }

      b {
        font-weight: 600;
        color: var(--blue-ink);
      }

      .benefit-text {
        min-width: 0;
      }

      small {
        color: var(--sub);
        font-size: inherit;
      }
    }
  }

  .sec {
    padding: 30px 24px 6px;
  }

  .eyebrow {
    display: inline-flex;
    font-size: 12px;
    font-weight: 600;
    color: var(--blue-ink);
    background: var(--blue-soft);
    border: 1px solid #cdeefb;
    padding: 5px 12px;
    border-radius: 999px;
  }

  .h2 {
    font-size: 21px;
    font-weight: 700;
    margin: 12px 0 4px;
    line-height: 1.25;
  }

  .cards {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 18px;
  }

  .c {
    border: 1px solid var(--line);
    border-radius: 16px;
    padding: 17px 18px;
    display: flex;
    gap: 14px;
    align-items: flex-start;
    background: #fff;

    .i {
      flex: none;
      width: 42px;
      height: 42px;
      border-radius: 12px;
      background: var(--blue-soft);
      color: var(--blue-ink);
      display: grid;
      place-items: center;
      font-size: 21px;
    }

    .t {
      font-size: 15.5px;
      font-weight: 600;
    }

    .d {
      font-size: 12.5px;
      color: var(--sub);
      font-weight: 400;
      margin-top: 4px;
      line-height: 1.55;

      b {
        color: var(--ink);
        font-weight: 600;
      }
    }
  }

  .flow {
    margin-top: 18px;
    display: flex;
    flex-direction: column;
  }

  .fstep {
    display: flex;
    gap: 14px;
    align-items: flex-start;
    position: relative;
    padding-bottom: 18px;

    &:not(:last-child)::before {
      content: '';
      position: absolute;
      left: 16px;
      top: 34px;
      bottom: 0;
      width: 2px;
      background: #cdeefb;
    }
  }

  .fnum {
    flex: none;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: var(--blue);
    color: #fff;
    display: grid;
    place-items: center;
    font-weight: 700;
    font-size: 14px;
    z-index: 2;
  }

  .ftx {
    padding-top: 4px;

    .ft {
      font-size: 14.5px;
      font-weight: 600;
    }

    .fd {
      font-size: 12.5px;
      color: var(--sub);
      font-weight: 400;
      margin-top: 2px;
      line-height: 1.55;
    }
  }

  .docs {
    margin: 24px 24px 0;
    background: var(--blue-tint);
    border: 1px solid #d9f0fb;
    border-radius: 16px;
    padding: 18px 20px;

    .dh {
      font-weight: 700;
      font-size: 14.5px;
      color: var(--ink);
      margin-bottom: 12px;

      span {
        display: block;
        font-size: 11px;
        font-weight: 400;
        color: var(--muted);
        margin-top: 2px;
      }
    }
  }

  .docchips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .dchip {
    background: #fff;
    border: 1px solid #cdeefb;
    color: var(--blue-ink);
    border-radius: 10px;
    padding: 8px 13px;
    font-size: 12.5px;
    font-weight: 500;
  }

  .risk {
    margin: 26px 24px 0;
    border: 1px solid var(--line);
    border-radius: 14px;
    padding: 15px 16px;
    background: #fafbfc;

    .rt {
      font-size: 12px;
      font-weight: 600;
      color: var(--sub);
      margin-bottom: 6px;
    }

    p {
      font-size: 10.5px;
      color: var(--muted);
      font-weight: 400;
      line-height: 1.6;
      margin: 0;
    }
  }

  .cta {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    max-width: 460px;
    margin: 0 auto;
    background: transparent;
    -webkit-backdrop-filter: none;
    backdrop-filter: none;
    border-top: 0;
    padding: 12px 16px;
    display: flex;
    z-index: 10;

    .main {
      flex: 1;
      background: var(--blue);
      color: #fff;
      border: 0;
      border-radius: 999px;
      padding: 15px 0;
      text-align: center;
      font-size: 15.5px;
      font-weight: 700;
      line-height: 1.2;
      text-decoration: none;
      box-shadow: 0 10px 22px -10px rgba(0, 173, 229, 0.8);
      cursor: pointer;
    }
  }

  .application-modal {
    position: fixed;
    inset: 0;
    z-index: 30;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 18px;
    background: rgba(18, 28, 36, 0.46);
  }

  .application-form {
    width: 100%;
    max-width: 430px;
    background: #fff;
    border-radius: 18px;
    padding: 22px;
    box-shadow: 0 22px 54px -22px rgba(0, 0, 0, 0.42);

    .modal-head {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 18px;
      margin-bottom: 18px;
    }

    .modal-title {
      font-size: 20px;
      font-weight: 700;
      color: var(--ink);
      line-height: 1.25;
    }

    .modal-subtitle {
      font-size: 12px;
      color: var(--muted);
      margin-top: 3px;
    }

    .modal-close {
      flex: none;
      width: 34px;
      height: 34px;
      border: 1px solid var(--line);
      border-radius: 50%;
      background: #fff;
      color: var(--sub);
      font-size: 23px;
      line-height: 1;
      cursor: pointer;
    }

    label {
      display: block;
      margin-top: 12px;
    }

    span {
      display: block;
      font-size: 12px;
      font-weight: 600;
      color: var(--sub);
      margin-bottom: 6px;
    }

    input {
      width: 100%;
      height: 46px;
      border: 1px solid var(--line);
      border-radius: 10px;
      padding: 0 13px;
      font-size: 15px;
      color: var(--ink);
      outline: none;

      &:focus {
        border-color: var(--blue);
        box-shadow: 0 0 0 3px rgba(8, 168, 220, 0.12);
      }
    }

    .form-error {
      margin-top: 12px;
      color: var(--red);
      font-size: 12px;
      font-weight: 600;
    }

    .submit {
      width: 100%;
      height: 50px;
      margin-top: 18px;
      border: 0;
      border-radius: 999px;
      background: var(--blue);
      color: #fff;
      font-size: 15px;
      font-weight: 700;
      cursor: pointer;

      &:disabled {
        cursor: default;
        background: #a7dceb;
      }
    }
  }

  @media (min-width: 900px) {
    .wrap {
      max-width: 1120px;
      padding-bottom: 72px;
      box-shadow: var(--shadow-soft);
    }

    .hero {
      padding: 54px 72px 58px;
      min-height: 408px;
      background: radial-gradient(
          620px 360px at 88% 6%,
          rgba(8, 168, 220, 0.18),
          transparent 64%
        ),
        radial-gradient(
          420px 260px at 12% 100%,
          rgba(236, 63, 98, 0.06),
          transparent 62%
        ),
        linear-gradient(135deg, #f7fcfe 0%, #ffffff 64%);

      .ey {
        font-size: 15px;
        margin-top: 50px;
      }

      h1 {
        font-size: 54px;
        line-height: 1.1;
        margin-top: 12px;
      }

      p {
        max-width: 560px;
        font-size: 17px;
        line-height: 1.72;
        margin-top: 20px;
      }
    }

    .top {
      gap: 24px;
    }

    .logo {
      gap: 12px;

      .mk {
        width: 42px;
        height: 42px;
        border-radius: 12px;
        font-size: 26px;
      }

      .nm {
        font-size: 25px;

        small {
          font-size: 12px;
        }
      }
    }

    .chip {
      font-size: 13px;
      padding: 8px 15px;
    }

    .kpis {
      max-width: 690px;
      gap: 14px;
      margin-top: 32px;
    }

    .kpi {
      border-radius: 16px;
      padding: 18px 18px;
      min-height: 96px;
      box-shadow: 0 12px 28px -24px rgba(20, 40, 60, 0.42);

      .n {
        font-size: 24px;
        line-height: 1.1;
      }

      .l {
        font-size: 13px;
        line-height: 1.25;
        margin-top: 8px;
      }
    }

    .cf {
      margin: 34px 72px 0;
      padding: 30px 34px;
      border-color: rgba(8, 168, 220, 0.7);
      box-shadow: 0 16px 40px -34px rgba(8, 126, 170, 0.56);

      .new {
        top: 30px;
        right: 34px;
        font-size: 12px;
      }

      .b {
        font-size: 13px;
        margin-bottom: 16px;
      }

      .ch {
        font-size: 32px;
      }

      ul {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 14px 36px;
        margin-top: 20px;
        padding-right: 0;
        align-items: start;
      }

      li {
        display: grid;
        grid-template-columns: 20px minmax(0, 1fr);
        font-size: 14.5px;
        column-gap: 10px;
        line-height: 1.55;
        min-height: 44px;
        padding: 0;
        border: 0;
        border-radius: 0;
        background: transparent;
        align-items: flex-start;

        span {
          width: 20px;
          height: 20px;
          font-size: 11px;
          margin-top: 2px;
        }

        .benefit-text {
          padding-top: 1px;
        }

        b {
          white-space: normal;
        }

        small {
          display: inline;
          white-space: nowrap;
        }
      }
    }

    .sec {
      padding: 54px 72px 8px;
    }

    .eyebrow {
      font-size: 13px;
      padding: 7px 14px;
    }

    .h2 {
      font-size: 30px;
      margin-top: 16px;
    }

    .cards {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 16px;
      margin-top: 24px;
    }

    .c {
      min-height: 136px;
      padding: 22px 24px;
      border-radius: 16px;

      .i {
        width: 50px;
        height: 50px;
        border-radius: 14px;
        font-size: 25px;
      }

      .t {
        font-size: 18px;
      }

      .d {
        font-size: 14px;
        line-height: 1.65;
      }
    }

    .flow {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 16px;
      margin-top: 24px;
    }

    .fstep {
      min-height: 124px;
      padding: 22px 24px;
      border: 1px solid var(--line);
      border-radius: 16px;
      background: #fff;
      gap: 16px;
      align-items: flex-start;

      &:not(:last-child)::before {
        display: none;
      }
    }

    .fnum {
      width: 42px;
      height: 42px;
      font-size: 16px;
    }

    .ftx {
      padding-top: 4px;

      .ft {
        font-size: 17px;
      }

      .fd {
        font-size: 13.5px;
        line-height: 1.6;
        margin-top: 7px;
      }
    }

    .docs {
      margin: 40px 72px 0;
      padding: 24px 26px;
      border-color: #d4edf7;

      .dh {
        font-size: 17px;

        span {
          font-size: 13px;
        }
      }
    }

    .docchips {
      gap: 10px;
    }

    .dchip {
      font-size: 14px;
      padding: 9px 14px;
      border-color: #c8e8f5;
    }

    .risk {
      margin: 22px 72px 0;
      padding: 18px 20px;
      border-radius: 16px;
      background: var(--panel);

      .rt {
        font-size: 14px;
        margin-bottom: 8px;
      }

      p {
        font-size: 12px;
        line-height: 1.72;
        color: #76818d;
      }
    }

    .cta {
      position: fixed;
      left: 50%;
      bottom: 32px;
      width: min(100%, 1120px);
      max-width: 1120px;
      margin: 0;
      padding: 0 72px;
      transform: translateX(-50%);
      justify-content: flex-end;
      z-index: 10;
      background: transparent;
      border-top: 0;
      box-shadow: none;

      .main {
        flex: none;
        width: 286px;
        font-size: 16px;
        padding: 15px 0;
        box-shadow: 0 14px 28px -12px rgba(8, 168, 220, 0.72);
      }
    }

    .application-modal {
      align-items: center;
    }
  }

  @media (min-width: 900px) and (max-width: 1080px) {
    .hero {
      padding: 48px 56px 54px;

      h1 {
        font-size: 48px;
      }
    }

    .cf,
    .docs,
    .risk {
      margin-left: 56px;
      margin-right: 56px;
    }

    .sec {
      padding-left: 56px;
      padding-right: 56px;
    }

    .cta {
      padding-left: 56px;
      padding-right: 56px;
    }

    .cf {
      padding: 28px 30px;

      .new {
        top: 28px;
        right: 30px;
      }

      ul {
        gap: 14px 24px;
      }
    }
  }
}
</style>
